var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "proof-item-b",
    width: 24,
    height: 32,
    x: 8,
    y: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    id: "proof-item-a",
    width: "116.7%",
    height: "112.5%",
    x: "-8.3%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.127109646   0 0 0 0 0.0591805127   0 0 0 0 0.197180707  0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.125490196   0 0 0 0 0.0588235294   0 0 0 0 0.196078431  0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#proof-item-a)",
    xlinkHref: "#proof-item-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FBF9F6",
    xlinkHref: "#proof-item-b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9FB1",
    d: "M21,24 C21.5522847,24 22,24.4477153 22,25 L22,26 C22,26.5522847 21.5522847,27 21,27 L13,27 C12.4477153,27 12,26.5522847 12,26 L12,25 C12,24.4477153 12.4477153,24 13,24 L21,24 Z M27,18 C27.5522847,18 28,18.4477153 28,19 L28,20 C28,20.5522847 27.5522847,21 27,21 L13,21 C12.4477153,21 12,20.5522847 12,20 L12,19 C12,18.4477153 12.4477153,18 13,18 L27,18 Z M27,12 C27.5522847,12 28,12.4477153 28,13 L28,14 C28,14.5522847 27.5522847,15 27,15 L13,15 C12.4477153,15 12,14.5522847 12,14 L12,13 C12,12.4477153 12.4477153,12 13,12 L27,12 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#DD5454",
    rx: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 8,
    y1: 8,
    y2: 4,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 8,
    y1: 8,
    y2: 4,
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 12 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.c60e1c6fa56b8335f984c6bef68e9af3.svg";
export { ForwardRef as ReactComponent };